// @flow
import classify from '@src/utils/typestyle';
import Popup from '../DynamicBase';

import * as PopupContent from '@components/popups/content/SaveForLater';

type PopupPropsType = {
  show: boolean,
  onCloseClick: () => void,
  anchorElement?: HTMLElement | null
};

type ContainerPropsType = {
  show: boolean,
  showPopup: boolean,
  togglePopup: () => void,
  hidePopupAndIcon: () => void
};

const styles = classify({
  container: {
    top: -15,
    left: 10,
    width: 54,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    position: 'absolute'
  },
  questionMark: {
    width: 14,
    cursor: 'pointer'
  }
});

const questionMark = '/images/question_mark_with_circle.svg';

const ActualPopup = (props: PopupPropsType) => {
  return (
    <Popup
      show={props.show}
      onCloseClick={props.onCloseClick}
      anchorElement={props.anchorElement}
      initialContent={PopupContent}
    />
  );
};

export default class SaveForLaterPopup extends React.Component<
  ContainerPropsType
> {
  questionMarkRef: void | React.ElementRef<'img'>;

  handlePopupToggle = (
    e: SyntheticMouseEvent<HTMLAnchorElement | HTMLImageElement>
  ) => {
    e.preventDefault();
    this.props.togglePopup();
  };

  render () {
    if (!this.props.show) return null;

    return (
      <span className={styles.container}>
        <img
          src={questionMark}
          onClick={this.props.togglePopup}
          className={styles.questionMark}
          ref={(ref) => {
            this.questionMarkRef = ref || undefined;
          }}
        />
        <ActualPopup
          show={this.props.showPopup}
          onCloseClick={this.props.hidePopupAndIcon}
          anchorElement={this.questionMarkRef}
        />
      </span>
    );
  }
}
